import GLightbox from "glightbox";

import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollSmoother);

export default function initGLightbox() {
    const lightbox = GLightbox({
        selector: ".glightbox, [data-glightbox]",
        loop: true,
        dragToleranceX: 1,

        autoplayVideos: true,
        autofocusVideos: false,
        videosWidth: "84vw",

        openEffect: "fade",
        closeEffect: "fade",
        slideEffect: "fade",

        onOpen: () => {
            if (MNK) ScrollSmoother.get().paused(true);
        },

        onClose: () => {
            if (MNK) ScrollSmoother.get().paused(false);
        },
    });

    /* Optional Add-on:
     * Trigger Galleries Externally
     */
    document.querySelectorAll("[data-gallery-name]").forEach((trigger) => {
        trigger.addEventListener("click", function (e) {
            e.preventDefault();

            const galleryName = this.getAttribute("data-gallery-name");
            const galleryTarget = this.getAttribute("href");

            let targetElement;

            if (galleryTarget) {
                targetElement = document.querySelector(
                    `[data-gallery="${galleryName}"][href="${galleryTarget}"]`
                );
            } else {
                targetElement = document.querySelector(
                    `[data-gallery="${galleryName}"]`
                );
            }

            if (targetElement) {
                lightbox.open(targetElement);
            } else {
                console.error(
                    `Target element for gallery "${galleryName}" not found.`
                );
            }
        });
    });
}
